import { useMemo } from 'react';
import cn from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var RewardRequestedCardTag = function RewardRequestedCardTag(_ref) {
  var label = _ref.label,
    color = _ref.color,
    className = _ref.className;
  var classNameColor = useMemo(function () {
    switch (color) {
      case 'SUCCESS':
        return 'tw-text-success-100 tw-bg-success-400';
      case 'WARN':
        return 'tw-text-warning-100 tw-bg-warning-400';
      default:
        return 'tw-text-alert-100 tw-bg-alert-400';
    }
  }, [color]);
  return /*#__PURE__*/_jsx("div", {
    className: cn('tw-px-1.2 tw-py-0.4 tw-rounded-1.2', classNameColor, className),
    children: label
  });
};
export default RewardRequestedCardTag;